import { render, staticRenderFns } from "./animal_info.vue?vue&type=template&id=4a428efa&"
import script from "./animal_info.vue?vue&type=script&lang=js&"
export * from "./animal_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports